var _path, _path2, _path3, _rect, _path4, _path5, _g, _ellipse, _rect2, _path6, _path7, _g2, _ellipse2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFtuxGraphicModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 159,
    viewBox: "0 0 306 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.155 133.083V144.207C159.424 154.96 136.805 147.76 128.926 142.816C128.926 139.108 130.301 130.338 128.462 126.594C121.958 116.896 114.064 110.907 105.736 101.137C103.748 98.8056 104.809 95.884 105.736 95.1115C102.955 88.6225 107.59 87.2321 110.834 87.6955C108.98 83.9876 113.152 82.1336 116.396 83.9876L121.958 87.2321C121.958 83.5241 125.218 83.0245 127.535 84.415L172.022 107.514C174.384 108.74 177.135 108.83 179.452 107.521C183.056 105.486 188.312 102.308 192.889 99.7105C196.133 97.8565 200.212 98.4127 201.695 100.638C203.179 102.862 203.086 105.415 201.695 107.127C199.687 109.599 197.987 111.298 189.644 120.105C185.302 124.689 183.31 130.302 183.155 133.083Z",
    fill: "#FDD506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.203 142.919C125.203 141.191 126.771 139.883 128.475 140.174C151.416 144.09 163.768 144.859 183.868 140.403C185.624 140.014 187.312 141.336 187.312 143.135V166.198C187.312 167.463 186.46 168.57 185.233 168.876C164.789 173.978 148.883 174.059 127.308 168.863C126.069 168.565 125.203 167.452 125.203 166.178V142.919Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 95.1112C105.273 94.6477 107.605 92.7576 111.313 94.6116C113.072 95.4911 124.74 104.152 125.667 105.543M108.517 86.7682C109.893 86.7682 110.649 87.139 113.616 88.6222C116.582 90.1054 127.536 97.2381 133.098 101.101M121.495 86.3047C125.203 88.6222 135.4 95.1112 141.426 99.3211M124.291 106.663C127.381 103.882 136.064 98.505 146.076 99.2466M176.188 108.089C166.455 105.543 148.378 108.089 150.696 126.166M149.32 134.473C151.947 134.936 158.219 135.585 162.298 134.473",
    stroke: "#F7F4EB",
    strokeWidth: 0.927001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.6007,
    height: 61.0295,
    rx: 4.635,
    transform: "matrix(0.996195 0.0871555 -0.0871529 0.996195 156.428 33.251)",
    fill: "#73A298"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.074 43.6101C158.187 42.3159 158.838 41.1285 159.869 40.3374L163.389 37.6356C164.309 36.9295 165.46 36.5938 166.615 36.6949L181.262 37.9764C182.417 38.0774 183.493 38.6079 184.276 39.463L187.273 42.735C188.151 43.693 188.586 44.9754 188.473 46.2697L184.928 86.7919C184.814 88.0862 184.163 89.2735 183.133 90.0646L179.613 92.7665C178.693 93.4726 177.542 93.8082 176.387 93.7072L161.739 92.4257C160.584 92.3246 159.509 91.7942 158.726 90.9391L155.728 87.6671C154.851 86.709 154.416 85.4267 154.529 84.1324L158.074 43.6101Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13524_3895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 36,
    width: 35,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.074 43.6087C158.187 42.3144 158.838 41.127 159.869 40.3359L163.389 37.6341C164.309 36.928 165.46 36.5924 166.615 36.6934L181.262 37.9749C182.417 38.076 183.493 38.6064 184.276 39.4615L187.273 42.7335C188.151 43.6915 188.586 44.9739 188.473 46.2682L184.928 86.7905C184.814 88.0847 184.163 89.2721 183.133 90.0632L179.613 92.765C178.693 93.4711 177.542 93.8068 176.387 93.7057L161.739 92.4242C160.584 92.3232 159.509 91.7927 158.726 90.9376L155.728 87.6656C154.851 86.7076 154.416 85.4252 154.529 84.1309L158.074 43.6087Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13524_3895)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2575,
    cy: 15.2574,
    rx: 15.2575,
    ry: 15.2574,
    transform: "matrix(0.996195 0.0871555 -0.0871529 0.996195 159.626 25.8716)",
    fill: "#B7CAC6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3433,
    cy: 20.3432,
    rx: 20.3433,
    ry: 20.3432,
    transform: "matrix(0.996195 0.0871555 -0.0871529 0.996195 154.114 30.4946)",
    fill: "#B7CAC6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.90019,
    cy: 8.90013,
    rx: 8.90019,
    ry: 8.90013,
    transform: "matrix(0.996195 0.0871555 -0.0871529 0.996195 165.957 26.4248)",
    fill: "white",
    fillOpacity: 0.3
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.67514,
    cy: 6.6751,
    rx: 6.67514,
    ry: 6.6751,
    transform: "matrix(0.996195 0.0871555 -0.0871529 0.996195 163.44 75.5713)",
    fill: "#BECFCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35.6007,
    height: 61.0295,
    rx: 4.635,
    transform: "matrix(0.707108 -0.707106 0.70711 0.707103 101.119 44.1978)",
    fill: "#73A298"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.113 49.5953C109.194 48.6766 108.703 47.4145 108.759 46.1165L108.952 41.6835C109.003 40.525 109.485 39.4274 110.305 38.6074L120.702 28.2108C121.522 27.3908 122.62 26.908 123.778 26.8576L128.211 26.6649C129.509 26.6084 130.771 27.0994 131.69 28.0181L160.453 56.781C161.372 57.6997 161.863 58.9617 161.806 60.2597L161.614 64.6927C161.563 65.8513 161.08 66.9489 160.26 67.7688L149.864 78.1655C149.044 78.9854 147.946 79.4683 146.788 79.5186L142.355 79.7114C141.057 79.7678 139.795 79.2769 138.876 78.3582L110.113 49.5953Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13524_3895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 26,
    width: 54,
    height: 54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.111 49.5953C109.193 48.6766 108.702 47.4145 108.758 46.1165L108.951 41.6835C109.001 40.525 109.484 39.4274 110.304 38.6074L120.701 28.2108C121.521 27.3908 122.618 26.908 123.777 26.8576L128.21 26.6649C129.508 26.6084 130.77 27.0994 131.689 28.0181L160.452 56.781C161.371 57.6997 161.862 58.9617 161.805 60.2597L161.612 64.6927C161.562 65.8513 161.079 66.9489 160.259 67.7688L149.863 78.1655C149.043 78.9854 147.945 79.4683 146.786 79.5186L142.353 79.7114C141.055 79.7678 139.793 79.2769 138.875 78.3582L110.111 49.5953Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13524_3895)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2574,
    cy: 15.2574,
    rx: 15.2574,
    ry: 15.2574,
    transform: "matrix(0.707108 -0.707106 0.70711 0.707103 97.5217 37.0059)",
    fill: "#B7CAC6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3433,
    cy: 20.3432,
    rx: 20.3433,
    ry: 20.3432,
    transform: "matrix(0.707108 -0.707106 0.70711 0.707103 97.5195 44.1987)",
    fill: "#B7CAC6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.90017,
    cy: 8.90014,
    rx: 8.90017,
    ry: 8.90014,
    transform: "matrix(0.707108 -0.707106 0.70711 0.707103 102.015 32.5107)",
    fill: "white",
    fillOpacity: 0.3
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.67513,
    cy: 6.67511,
    rx: 6.67513,
    ry: 6.67511,
    transform: "matrix(0.707108 -0.707106 0.70711 0.707103 138.046 66.0298)",
    fill: "#BECFCB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_13524_3895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.807 96.989L140.473 -55.9482H165.14L152.807 96.989Z",
    fill: "url(#paint0_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 82.1925L165.142 235.13H140.474L152.808 82.1925Z",
    fill: "url(#paint1_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 89.5895L87.9201 228.387L65.9194 215.685L152.808 89.5895Z",
    fill: "url(#paint2_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.736 89.7007L26.6186 177.148L14.4844 156.131L152.736 89.7007Z",
    fill: "url(#paint3_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 89.5895L-0.129883 101.923V77.2558L152.808 89.5895Z",
    fill: "url(#paint4_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.659 89.5907L13.6002 24.6585L26.2518 2.74541L152.659 89.5907Z",
    fill: "url(#paint5_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.659 89.5907L64.5821 -36.2626L86.7523 -49.0625L152.659 89.5907Z",
    fill: "url(#paint6_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.659 89.5907L217.742 228.112L240.082 215.215L152.659 89.5907Z",
    fill: "url(#paint7_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.659 89.5907L278.943 177.124L291.298 155.725L152.659 89.5907Z",
    fill: "url(#paint8_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 89.5895L305.746 101.923V77.2558L152.808 89.5895Z",
    fill: "url(#paint9_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 89.5895L292.154 25.0209L279.333 2.81448L152.808 89.5895Z",
    fill: "url(#paint10_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.736 89.7007L241.304 -35.8558L219.022 -48.7201L152.736 89.7007Z",
    fill: "url(#paint11_radial_13524_3895)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13524_3895)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.997,
    cy: 163.626,
    rx: 128.387,
    ry: 33.8119,
    transform: "rotate(-2.05402 154.997 163.626)",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.404 30.0977C197.424 29.5344 197.826 28.0372 198.956 28.0393L209.097 28.0577C209.49 28.0584 209.854 27.8499 210.052 27.5105L215.132 18.7979C215.697 17.8277 217.182 18.2255 217.187 19.3485L217.23 29.4338C217.232 29.8268 217.442 30.1891 217.783 30.385L226.575 35.4399C227.555 36.0032 227.154 37.5003 226.023 37.4983L215.882 37.4799C215.489 37.4792 215.125 37.6876 214.927 38.0271L209.847 46.7397C209.282 47.7098 207.797 47.3121 207.792 46.189L207.749 36.1037C207.748 35.7108 207.537 35.3484 207.196 35.1526L198.404 30.0977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.137 134.766C216.647 134.484 216.847 133.736 217.412 133.737L222.483 133.746C222.68 133.746 222.862 133.642 222.96 133.472L225.5 129.116C225.783 128.631 226.526 128.83 226.528 129.391L226.55 134.434C226.55 134.63 226.656 134.812 226.826 134.91L231.222 137.437C231.712 137.719 231.511 138.467 230.946 138.466L225.875 138.457C225.679 138.457 225.497 138.561 225.398 138.731L222.858 143.087C222.575 143.572 221.833 143.373 221.831 142.812L221.809 137.769C221.808 137.572 221.703 137.391 221.533 137.293L217.137 134.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0724 136.042C94.3358 136.064 94.0468 135.095 94.6751 134.71L100.313 131.254C100.532 131.12 100.662 130.88 100.656 130.624L100.499 124.049C100.482 123.317 101.442 123.031 101.829 123.653L105.3 129.238C105.435 129.456 105.676 129.585 105.932 129.578L112.542 129.38C113.278 129.358 113.567 130.326 112.939 130.711L107.301 134.167C107.083 134.301 106.952 134.541 106.958 134.797L107.115 141.372C107.132 142.104 106.172 142.39 105.786 141.768L102.315 136.183C102.179 135.965 101.939 135.836 101.682 135.843L95.0724 136.042Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13524_3895",
    x: -6.63507,
    y: 96.1977,
    width: 323.265,
    height: 134.856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6609,
    result: "effect1_foregroundBlur_13524_3895"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_13524_3895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.888 89.9516) scale(160.729 144.269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13524_3895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 305.777,
    height: 272.455,
    fill: "white",
    transform: "translate(0 -37.4551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtuxGraphicModal);
export default __webpack_public_path__ + "static/media/ftux-graphic-modal.bb02abbd4a6a17b3f654772d4f655d3c.svg";
export { ForwardRef as ReactComponent };